import { render } from "./Banner.vue?vue&type=template&id=87b4a7b6&ts=true"
import script from "./Banner.ts?vue&type=script&lang=ts&external"
export * from "./Banner.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__